import React from "react";
import { ImageOff } from "lucide-react";
import AuthImage from "@/components/AuthImage";

function Slot({ id, label, tone, onOpen, testid }) {
  return (
    <div className="flex-1 min-w-0">
      <div className={`text-[10px] font-bold uppercase tracking-wide mb-1 ${tone}`}>{label}</div>
      {id ? (
        <button onClick={() => onOpen && onOpen(id)} className="block w-full" data-testid={testid}>
          <AuthImage fileId={id} thumb className="w-full aspect-[4/3] object-cover rounded-lg border border-slate-200 hover:opacity-90 transition-opacity" />
        </button>
      ) : (
        <div className="w-full aspect-[4/3] rounded-lg border border-dashed border-slate-300 flex flex-col items-center justify-center text-[11px] text-slate-400" data-testid={`${testid}-missing`}>
          <ImageOff className="h-4 w-4 mb-1" />kein Foto
        </div>
      )}
    </div>
  );
}

export default function BeforeAfter({ before, after, onOpen, testid = "before-after" }) {
  return (
    <div className="flex gap-2" data-testid={testid}>
      <Slot id={before} label="Vorher" tone="text-red-600" onOpen={onOpen} testid={`${testid}-before`} />
      <Slot id={after} label="Nachher" tone="text-green-600" onOpen={onOpen} testid={`${testid}-after`} />
    </div>
  );
}
